import { Component } from 'react';
import AdminTable from 'layouts/AdminTable';
import { combineStyles } from 'helpers/helpers';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx';
import FormControlButtons from 'components/FormControlButtons/FormControlButtons';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import SimpleWysiwyg from 'components/FormTextInput/SimpleWysiwyg';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import LabelWithTooltip from 'components/LabelWithTooltip/LabelWithTooltip';

import { get, post, put } from '../../helpers/apiHelpers';
import LettersCounter from './LettersCounter';

class Form extends Component {
  state = {
    label: '',
    slug: '',
    title: '',
    metaDescription: '',
    content: '',
    inFooter: false,
    position: 0,
  };

  pageId = this.props.match.params.id;

  isEdit = this.props.location.pathname.includes('edit');

  componentDidMount() {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
    this.pageId &&
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      get(`pages/${this.pageId}`).then(response => this.setState(response));
  }

  handleContent = event => {
    const content = event.target.value;
    this.setState({ content });
  };

  handleInputChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  validateForm = () =>
    this.state.slug && this.state.title && this.state.content;

  // eslint-disable-next-line consistent-return -- FIXME
  handleSubmit = () => {
    if (!this.validateForm()) {
      return toast.error(this.props.t('pages.fillAllFields'));
    }

    const { position, ...restState } = this.state;
    const data = {
      ...restState,
      // eslint-disable-next-line radix -- FIXME
      ...(restState.inFooter ? { position: parseInt(position) } : {}),
    };

    const action = this.isEdit
      ? put(`/pages/${this.pageId}`, data)
      : post('/pages', data);

    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    action.then(
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
      res => this.props.history.push('/admin/pages-creator'),
      // eslint-disable-next-line promise/prefer-await-to-callbacks -- FIXME
      error => {
        if (error.response.data.violations) {
          return toast.error(
            error?.response?.data?.violations
              .map(
                violation => `${violation.propertyPath} - ${violation.message}`
              )
              .filter(Boolean)
              .join(' ')
          );
        }
        return toast.error(this.props.t('pages.cannotSave'));
      }
    );
  };

  render() {
    const { classes, t } = this.props;
    return (
      <AdminTable title={t('pages.addNew')}>
        <FormTextInput
          label={
            <LabelWithTooltip
              label={`${t('pages.pageUrl')}*`}
              tooltip={t('pages.pageUrl.tooltipWarning')}
            />
          }
          classes={classes}
          name="slug"
          value={this.state.slug}
          handleChange={this.handleInputChange}
          inputSize={12}
          maxLength={64}
          helpText={t('pages.pageUrl.example', 'np. "about-us"')}
        />
        <FormTextInput
          label={
            <LabelWithTooltip
              label={`${t('pages.title')}*`}
              tooltip={t('pages.title.tooltip')}
            />
          }
          classes={classes}
          name="title"
          value={this.state.title}
          handleChange={this.handleInputChange}
          inputSize={12}
          maxLength={60}
        />
        <FormTextInput
          label={
            <LettersCounter
              label={t('pages.metaDesc')}
              wordsCount={this.state.metaDescription.length}
            />
          }
          classes={classes}
          name="metaDescription"
          value={this.state.metaDescription}
          handleChange={this.handleInputChange}
          inputSize={12}
          maxLength={300}
          rows={2}
          multiline={true}
        />
        <p
          style={{
            margin: '20px 0 10px',
            color: 'rgba(0,0,0,.46)',
            fontWeight: 400,
          }}
        >
          {t('pages.pageContent')} *
        </p>
        <SimpleWysiwyg
          handleChange={this.handleContent}
          value={this.state.content}
        />
        <FormControlButtons
          classes={classes}
          discardText={this.props.t('common.shared.cancel')}
          submitText={this.props.t('common.shared.save')}
          cancelPath="/admin/pages-creator"
          handleSubmit={this.handleSubmit}
        />
      </AdminTable>
    );
  }
}

const combinedStyles = combineStyles(extendedFormsStyle, buttonsStyle);

const enhance = compose(withStyles(combinedStyles), withTranslation());

export default enhance(Form);
